<template>
    <div class="ScenicArea hml_whplt">
        <div class="swiper-container mainScenicSwiper">
            <div class="swiper-wrapper">
                <div
                class="swiper-slide"
                v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
                :key="index"
                @click="slideClick(index)"
                >
                    <img :src="item.thumb">
                </div>
            </div>
            <!-- 分页器 -->
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {

        }
    },
    methods: {
        slideClick(index){
            this.setIndex({levelThreeIndex: index});
            this.$router.push("/panorama");
        },
        ...publicData.mapMutations(["setIndex"])
    },
    mounted(){
        let _this = this;
		var swiper1 = new Swiper('.mainScenicSwiper', {
			slidesPerView: "auto",
			centeredSlides: true,
            initialSlide: _this.levelThreeIndex,
			pagination: {
				el: '.swiper-pagination',
				dynamicBullets: true,
			},
		});
    },
    computed: {
        ...publicData.mapState(['allData','firstLevelIndex','secondLevelIndex','levelThreeIndex'])
    },
}
</script>

<style lang="scss" scoped>
.ScenicArea{
    // padding-top: .92rem;
    display: flex;
    align-items: center;
    .mainScenicSwiper {
        width: 100%;
        height: 8.4rem;
        overflow: visible;
        /deep/.swiper-pagination{
            bottom: -.64rem;
            .swiper-pagination-bullet{
                width: .7rem;
                height: .1rem;
                background: #ccc;
                border-radius: 0;
                transform: scale(1);
                opacity: 0.3;
                &.swiper-pagination-bullet-active{
                    background: #424242;
                    opacity: 1;
                    &.swiper-pagination-bullet-active + .swiper-pagination-bullet{
                        opacity: 0.8;
                    }
                }
                &.swiper-pagination-bullet-active-prev{
                    opacity: 0.8!important;
                }
            }
        }
        .swiper-slide {
            width: 5.6rem;
            height: 8.4rem;
            font-size: .5rem;
            color: #333;
            border-radius: .1rem;
            text-align: center;
            transition: 300ms;
            box-shadow: 0rem .5rem .7rem -.2rem rgba(0,0,0,0.4);
            overflow: hidden;
            img{
                height: 100%;
                border-radius: .1rem;
            }
            // 除去当前激活的DOM,其他DOM都缩小0.8;
            &.swiper-slide:not(.swiper-slide-active){
                transform: scale(0.8);
            }
        }
    }
}
</style>